// extracted by mini-css-extract-plugin
export var activeDot = "_33-c";
export var buttonContainer = "_33-9";
export var channelButton = "_33-a";
export var clickable = "_33-d";
export var content = "_33-0";
export var contentFull = "_33-2";
export var contentThird = "_33-1";
export var contentWrapper = "_33-7";
export var description = "_33-5";
export var heightShort = "_33-f";
export var image = "_33-3";
export var imageContainer = "_33-4";
export var selectButton = "_33-e";
export var spinnerContainer = "_33-b";
export var titleContent = "_33-8";
export var titleWrapper = "_33-6";